import { AutogenModelTariffLookup, AutogenRowTariffLookup } from "./autogen/AutogenModelTariffLookup";

export class ModelTariffLookup extends AutogenModelTariffLookup<RowTariffLookup> {
	constructor() {
		super(RowTariffLookup);
	}
}

export class RowTariffLookup extends AutogenRowTariffLookup {
}